export const convertDateToUnix = (date) => {
	return new Date(date).getTime() / 1000;
};
